export function SubmitError({ message }: { message: string | null }) {
  if (!message) return null;
  return (
    <div className="mb-5 rounded border border-error bg-error-light px-4 py-3 text-sm text-error">
      {message}
    </div>
  );
}
